<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <!-- FlowTemplate -->
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Select Workflow*</mat-label>
      <mat-select formControlName="flowTemplate">
        <mat-option *ngFor="let flowTemplate of flowTemplates"
                    [value]="flowTemplate.id">
          {{ flowTemplate.title }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="inputForm.controls['flowTemplate'].hasError('required')">
        FlowTemplate is required!
      </mat-error>
    </mat-form-field>
  </div>
  <div *ngIf="isFromSetWorkFlow" class="flex flex-col">
    <mat-radio-group class="radio-group" formControlName="radio" [(ngModel)]="selectedFilterOption">
      <mat-radio-button *ngFor="let filterOption of oicReturnFilterOptions" [value]="filterOption.key">
        {{filterOption.value}}
      </mat-radio-button>
    </mat-radio-group>
    <mat-checkbox formControlName="chkSkipReturnsWithFlow"
                  [(ngModel)]="skipReturnsWithFlow">{{skipReturnsWithFlowDisplayText}}</mat-checkbox>
    <mat-checkbox formControlName="chkApplyToNewReturns"
                  [(ngModel)]="applyToNewReturns">{{applyToNewReturnsText}}</mat-checkbox>
  </div>
</form>
